import { SystemSetting } from 'actions/actionTypes';

export const loadSystemSettingListRequest = (settingGroups) => ({ type: SystemSetting.LOAD_SYSTEM_SETTING_LIST_REQUEST, payload: settingGroups });
export const loadSystemSettingListRequestSuccess = (responseData) => ({ type: SystemSetting.LOAD_SYSTEM_SETTING_LIST_REQUEST_SUCCESS, payload: responseData });
export const loadSystemSettingListRequestFailure = (errorMessage) => ({ type: SystemSetting.LOAD_SYSTEM_SETTING_LIST_REQUEST_FAILURE, payload: errorMessage });
